import { Injectable } from '@angular/core';

import { type EditPageSettings, type PageSettingsUpdateRequest } from '@common/types/page-settings.type';

@Injectable({
    providedIn: 'root',
})
export class PageSettingsService {
    public mapEditPageSettingsToEditPageSettingsRequest(pageSettings: EditPageSettings): PageSettingsUpdateRequest {
        return {
            name: pageSettings.name,
            url: pageSettings.url,
            seo_name: pageSettings.seoName,
            description: pageSettings.description,
            keywords: pageSettings.keywords,
            shared_img: pageSettings.sharedImg instanceof File ? pageSettings.sharedImg : undefined,
            can_be_indexed: pageSettings.canBeIndexed,
        };
    }
}
